import { render, staticRenderFns } from "./PerformanceFeedback.vue?vue&type=template&id=34f3df4a&"
import script from "./PerformanceFeedback.vue?vue&type=script&lang=js&"
export * from "./PerformanceFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports